import { CheckoutError } from "@treefort/lib/errors"

export async function getAndroidCheckoutData() {
  throw new CheckoutError("Can't call getAndroidCheckoutData on Web")
}
